

export let  BASE_API = 'https://dummyjson.com/products';

// import axios from "axios";

// export default axios.create({
//     BASE_API : 'https://dummyjson.com/products',
// })